import { render, staticRenderFns } from "./Competitor.vue?vue&type=template&id=89b39cca&scoped=true"
import script from "./Competitor.vue?vue&type=script&lang=js"
export * from "./Competitor.vue?vue&type=script&lang=js"
import style0 from "./Competitor.vue?vue&type=style&index=0&id=89b39cca&prod&scoped=true&lang=css"
import style1 from "./Competitor.vue?vue&type=style&index=1&id=89b39cca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89b39cca",
  null
  
)

export default component.exports